export const PLATS = [
  { key: 'steam',    label: 'Steam',       badge: 'Tiered Fee' },
  { key: 'psn',      label: 'PlayStation', badge: null },
  { key: 'xbox',     label: 'Xbox',        badge: null },
  { key: 'nintendo', label: 'Nintendo',    badge: null },
  { key: 'epic',     label: 'Epic',        badge: null },
  { key: 'ios',      label: 'iOS',         badge: null },
  { key: 'android',  label: 'Android',     badge: null },
  { key: 'other',    label: 'Other',       badge: 'Manual Deal' },
];

export const MN = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
export const NM = 36;           // forecast months (0-35)
export const PRE_MONTHS = 36;   // max pre-forecast cost months (-36 to -1)
export const TOTAL_COST_MONTHS = NM + PRE_MONTHS; // 72 total slots
// Array index = monthIndex + PRE_MONTHS
// e.g. forecast month 0 → array index 36; pre-forecast month -6 → array index 30
export const toArrayIdx  = (monthIdx) => monthIdx + PRE_MONTHS;
export const toMonthIdx  = (arrayIdx) => arrayIdx - PRE_MONTHS;

export const CURRENCIES = ['USD','GBP','EUR','JPY','AUD','CAD'];
export const DEFAULT_GAMES = ['Warpunk', 'Athena', 'Monaco'];

export const COST_FIELDS = [
  { key: 'devAdvances', label: 'Development Advances' },
  { key: 'loc',         label: 'LOC' },
  { key: 'qa',          label: 'QA' },
  { key: 'otherPub',    label: 'Other Publishing Costs' },
  { key: 'marketing',   label: 'Marketing Costs' },
];
